<template>
    <div class="page-actions" :class="{ minified: isMinified }">
        <div class="three-dots" @click="toggleOptions">
            <i class="fa fa-ellipsis-h"></i>
        </div>

        <div class="action-options">
            <csv-button v-if="isTableView" class="option" />
            <tutorial-button v-if="!isFdaFriendly" class="option" />
            <share-button class="option" />
            <!-- key should provide report link update between treatments -->
            <report-button
                v-if="isTreatmentPage"
                :key="selectedTreatment._id + '_report'"
                class="option"
            />
            <!-- key should provide share-link update between treatments -->
            <share-to-patient
                v-if="showShareToPatient"
                :key="selectedTreatment._id"
                class="option"
            />
            <print-button v-if="!isFdaFriendly && isWellPage" class="option" />
            <Delayed-slide-alert class="option" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { ROUTES, TREATMENT_PAGE_VIEWS } from '../../../business/const'
import CsvButton from './CsvButton'
import PrintButton from './PrintButton'
import ShareButton from '../ShareButton'
import TutorialButton from './TutorialButton'
import ShareToPatient from './ShareToPatient'
import ReportButton from './ReportButton'
import DelayedSlideAlert from '../common/DelayedSlideAlert'

export default {
    name: 'PageActions',
    components: {
        DelayedSlideAlert,
        ReportButton,
        CsvButton,
        TutorialButton,
        PrintButton,
        ShareButton,
        ShareToPatient
    },
    data: () => ({
        isMinified: true
    }),
    computed: {
        ...mapState({
            currentView: state => state.navigation.currentView,
            selectedTreatment: state => state.timelapse.selectedTreatment
        }),
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly'
        }),
        isWellPage() {
            const { WELL } = ROUTES

            return this.$route.name === WELL
        },
        isTreatmentPage() {
            const { TREATMENTS } = ROUTES

            return this.$route.name === TREATMENTS
        },
        isTableView() {
            const { TREATMENTS } = ROUTES
            const { PERFORMANCE_TABLE, ISTANBUL_TABLE } = TREATMENT_PAGE_VIEWS

            return (
                this.$route.name === TREATMENTS &&
                [PERFORMANCE_TABLE, ISTANBUL_TABLE].includes(this.currentView)
            )
        },
        showShareToPatient() {
            const { TREATMENTS } = ROUTES
            const { WELL_CARDS, ISTANBUL_TABLE, PERFORMANCE_TABLE } = TREATMENT_PAGE_VIEWS
            return (
                this.$route.name === TREATMENTS &&
                [WELL_CARDS, ISTANBUL_TABLE, PERFORMANCE_TABLE].includes(this.currentView)
            )
        }
    },
    methods: {
        toggleOptions() {
            this.isMinified = !this.isMinified
        }
    }
}
</script>

<style lang="scss" scoped>
.page-actions {
    display: flex;
    flex-wrap: nowrap;

    .three-dots,
    .option {
        width: 40px;
    }

    .action-options {
        display: flex;
    }

    @media screen and #{$new-break4close} {
        flex-direction: column;
        background-color: $dark-3;

        .three-dots {
            border: solid 1px $dark;
            height: $sub-header-height;
            line-height: $sub-header-height;
            font-size: 18px;
            text-align: center;
        }
        .action-options {
            flex-direction: column-reverse;
            position: absolute;
            right: 0;
            top: $sub-header-height;
            background-color: $dark-3;

            .option {
                height: 50px;
                border-radius: 0 !important;
                border: solid 1px $dark !important;
            }
        }

        &.minified {
            .action-options {
                display: none;
            }
        }
    }
    @media screen and #{$new-break5open} {
        .three-dots {
            display: none;
        }
    }

    @media print {
        display: none;
    }
}
</style>
